export default __webpack_public_path__ + "static/media/main.cbebbfa6.jpg";